import {DemandForecastPerType, getTotalValueForShippingTypes} from '@domain/material-demand'
import {formatTons} from '@hconnect/uikit/src/common'

export const formatDemandValue = (value: null | undefined | number, locale: string) => {
  if (value === null || value === undefined) return '-'
  return formatTons(value, locale)
}

export const formatCombinedDemandValue = (
  values: Partial<DemandForecastPerType>,
  locale: string
) => {
  const combinedValue = getTotalValueForShippingTypes(values)
  return formatDemandValue(combinedValue, locale)
}
